module.exports = __webpack_public_path__ + "static/img/6.bfbe3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/6.png
// module id = 4HGI
// module chunks = 0